export { default } from './useTeamCoursesTranslation';
